import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getTransactionCompleteDialog } from '../Selectors'
import { setTransactionCompleteDialog } from '../ActionCreators'
import { clearCart } from '../../actions/cart'
import { clearPromotionsOnOrder } from '../../actions/promotion'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'
import { resetCFD } from '../../VNCustomerFacingDisplay/ActionCreators'
import useRemoteOrderTotal from '../../hooks/useRemoteOrderTotal'
import { clearOrderInProgress } from '../../actions/order'
import { isEmpty } from '../../VNUtil/VNUtils'
import { getOrderInProgress } from '../../selectors/order'
import { getPpiOrderDetails, getPpiConfigurations } from '../../VNPPI/Selectors'
import { getActiveAttendantId } from '../../selectors/attendant'
import { getActiveRevenueCenter } from '../../selectors/revenueCenter'
import { handlePpiReportOrder } from '../../VNPPI/Utils'
import { getDeviceSerial } from '../../utils/deviceData'

export const VNTransactionCompleteDialog = () => {
  const dispatch = useDispatch()

  const history = useHistory()

  const open = useSelector((state) => getTransactionCompleteDialog(state))

  const [, , resetOrderTotals] = useRemoteOrderTotal()
  const order = useSelector(getOrderInProgress)
  const ppiConfigurations = useSelector(getPpiConfigurations)
  const ppiOrderDetails = useSelector((state) => getPpiOrderDetails(state, order?.uuid))
  const activeAttendantId = useSelector(getActiveAttendantId)
  const activeRevenueCenter = useSelector(getActiveRevenueCenter)

  const posInfo = {
    venueId: process.env.REACT_APP_VENUE_UUID,
    userId: activeAttendantId,
    vendorName: activeRevenueCenter.name,
    deviceId: getDeviceSerial(),
  }

  if (!open) return null

  return (
    <VNDialog
      open={open}
      subTitle={'Transaction Complete'}
      primaryButtonText={'NEW ORDER'}
      primaryButtonCountdownTime={10}
      onPrimaryButtonClick={() => {
        if (!isEmpty(order) && !isEmpty(ppiOrderDetails) && !isEmpty(ppiConfigurations) && !isEmpty(activeRevenueCenter)) {
          handlePpiReportOrder(
            order,
            ppiConfigurations,
            ppiOrderDetails,
            posInfo,
            activeRevenueCenter.customerAttributes?.ppiExtras,
          )
        }

        // clear cart
        dispatch(clearCart())

        // clear promotions on order
        dispatch(clearPromotionsOnOrder())

        // reset order totals
        resetOrderTotals()

        // navigate CFD back to IDLE
        sendCFDScreenNav(CFD_SCREEN.IDLE)

        // navigate POS back to
        history.push('/concession-order')

        // reset the state locally
        dispatch(resetCFD(true))

        // close dialog
        dispatch(setTransactionCompleteDialog(false))

        dispatch(clearOrderInProgress())
      }}
    />
  )
}
